<template>
  <v-container fluid class="payrollentry-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/payrollentry/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-select
                  outlined
                  dense
                  persistent-hint
                  prepend-inner-icon="mdi-magnify"
                  class="mb-4"
                  placeholder="Employee"
                  single-line hint="Please choose the employee"
                  :items="employees.map(x => {return {text: x.employeename, value: x._id};})"
                  v-on:change="filterCurrentEmployee($event)"
                  v-bind:value="currentEmployeeId"
                >
                </v-select>   
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="payrollentries-table"
              show-select
              single-select
              item-key="_id"
              sort-by="payrollentrynum"
              :footer-props="footer"
              :headers="headers"
              :items="payrollentries.filter(payroll=>payroll.employeeid==this.currentEmployeeId)"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Payroll Entry?
                    </v-card-title>

                    <v-card-text>
                      {{ deletePayrollEntry.employeename + ' - ' + deletePayrollEntry.accountname  }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletePayrollEntry)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                {{ 
                  employees.find(employee=>employee._id == item.employeeid)!==undefined ? employees.find(employee=>employee._id == item.employeeid)['employeecode'] : ''
                }}
              </template>
              <template v-slot:item.accountid="{ item }">
                {{
                  accounts.find(account=>account._id == item.accountid)!==undefined ? accounts.find(account=>account._id == item.accountid)['accountname'] : ''
                }}
              </template>
              <template v-slot:item.value="{ item }">
                {{ item.value }}
              </template>
              <template v-slot:item.payrollentriestatus="{ item }">
                <v-chip
                  :color="!item.payrollentriestatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.payrollentriestatus }}
                </v-chip>
              </template>
              <template v-slot:item.paydate="{ item }">
                {{ new Date(item.paydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.postdate="{ item }">
                {{ new Date(item.postdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'payrollentryList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deletePayrollEntry: {},
      headers: [
        { text: 'Employee', value: 'employeeid' },
        { text: 'Account', value: 'accountid' },
        { text: 'Entry', value: 'paydate' },
        { text: 'Post', value: 'postdate' },
        { text: 'Increase', value: 'paycredit' },
        { text: 'Decrease', value: 'paydebit' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      list: [],
      payrollentryid: ['admin', 'payrollentry'],
    }
  },

  computed: {
    ...mapState('PayrollEntry', ['payrollentries', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating', 'currentEmployeeId']),
    ...mapState('Employee', ['employees']),
    ...mapState('Account', ['accounts']),
  },
  created() {
    this.getPayrollEntriesRequest();
    if(this.employees.length==0){this.getEmployeesRequest()}
    if(this.accounts.length==0){this.getAccountsRequest()}
    this.list = this.payrollentries.filter(payroll=>payroll.employeeid==this.currentEmployeeId);
  },
  methods: {
    ...mapActions('PayrollEntry', ["getPayrollEntriesRequest","deletePayrollEntryRequest","setCurrentEmployeeId","createPayrollEntryRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('Account', ["getAccountsRequest"]),
    editItem(item) {
      this.$router.push({ name: 'PayrollEntryEdit', params: item })
    },
    filterCurrentEmployee(value){
      this.setCurrentEmployeeId(value);
      this.list = this.payrollentries.filter(payroll=>payroll.employeeid==this.currentEmployeeId);
    },
    deleteItem(item) {
      this.deletePayrollEntryRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletePayrollEntry = {
        _id: item._id,
        employeename: this.employees.find(employee=>employee._id == item.employeeid)['employeename'],
        accountname: this.accounts.find(account=>account._id == item.accountid)['accountname'],
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
